import React, { useState, useEffect } from 'react';
import Navigation from './components/Navigation';
import SummaryDashboard from './components/SummaryDashboard';
import AllProductsReport from './components/AllProductsReport';
import ToxicReport from './components/ToxicReport';
import GenericReport from './components/GenericReport';
import { Warehouse } from 'lucide-react';
import { fetchReportTypes } from './services/api';

// Report type labels for display
const REPORT_LABELS = {
  all: 'Όλα τα Προϊόντα',
  toxic: 'Τοξικά',
  all_gamingparts: 'GamingParts',
  all_nonito: 'Nonito',
  all_fbs: 'FBS',
  all_ap: 'Όλα AP',
  tobesold: 'Προς ρευστοποίηση',
  stox: 'Στοχ',
  dif: 'Μεγάλες διαφορές',
  dif_stock: 'Μεγάλες διαφορές Stock',
  sales200: 'Πωλήσεις>200 ή Τζίρος>10000',
  bestprice: 'Καλύτερη τιμή ever',
  summer: 'Καλοκαίρι',
  forqogita: 'Qogita',
  forparfium: 'Για πώληση σε Parfium',
  forqogita2: 'Για Qogita Κομμένα',
  pol60: 'Πωλ60',
  stox1: 'Λοιπά',
  silmetan: 'Συλμετάν',
  best_skroutz: 'Best sellers - Best picks',
  emag: 'Emag',
  google: 'Google',
  deals: 'Deals',
  stoxamazon: 'ΣτοχAmazon',
  temp: 'Προσωρινή αποθήκη',
  apol: 'Απολεσθέντα',
  pkat: 'Προς καταστροφή',
  kat: 'Κατεστραμένα',
  xal: 'Μη λειτουργικά',
  otp: 'ΟΤΠ',
  ebay: 'EBAY',
  apacs: 'Courier',
  danger: 'Για έλεγχο',
  dangertoxic: 'Για έλεγχο τοξικά',
  apoGm: 'Δημιουργηθέντα τεμάχια',
  must03profit: 'Must03 Κερδοφορία',
};

function App() {
  const [activeTab, setActiveTab] = useState('summary');
  const [reportTypes, setReportTypes] = useState([]);

  useEffect(() => {
    const loadTypes = async () => {
      try {
        const types = await fetchReportTypes();
        setReportTypes(types);
      } catch (err) {
        console.error('Error loading report types:', err);
      }
    };
    loadTypes();
  }, []);

  const getReportLabel = (type) => {
    const found = reportTypes.find(r => r.key === type);
    return found?.label || REPORT_LABELS[type] || type;
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'summary':
        return <SummaryDashboard />;
      case 'all':
        return <AllProductsReport />;
      case 'toxic':
        return <ToxicReport />;
      default:
        // Use generic report for all other types
        return <GenericReport reportType={activeTab} title={getReportLabel(activeTab)} />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <header className="bg-blue-700 text-white shadow-lg">
        <div className="mx-auto max-w-7xl px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Warehouse className="h-8 w-8" />
              <div>
                <h1 className="text-2xl font-bold">Karantina</h1>
                <p className="text-sm text-blue-200">Έλεγχος Αποθήκης</p>
              </div>
            </div>
            {activeTab !== 'summary' && (
              <div className="text-right">
                <span className="rounded-full bg-blue-600 px-3 py-1 text-sm">
                  {getReportLabel(activeTab)}
                </span>
              </div>
            )}
          </div>
        </div>
      </header>

      {/* Navigation */}
      <Navigation activeTab={activeTab} onTabChange={setActiveTab} />

      {/* Main Content */}
      <main className="mx-auto max-w-7xl px-4 py-6">
        {renderContent()}
      </main>

      {/* Footer */}
      <footer className="mt-8 border-t border-gray-200 bg-white py-4 text-center text-sm text-gray-500">
        Karantina Inventory Management &copy; {new Date().getFullYear()}
      </footer>
    </div>
  );
}

export default App;
